import React from 'react'

/** Monochrome status tag (mock `.ord-tag`): solid ink when `solid`, grey outline otherwise. */
export default function OrganizerStatusTag({ solid = false, children, className = '' }) {
    return (
        <span
            className={`inline-flex h-[22px] items-center whitespace-nowrap rounded-[5px] border px-2 text-xs font-medium ${
                solid ? 'border-[#272727] bg-[#272727] text-white' : 'border-[#dbdadf] bg-white text-[#5b5f6e]'
            } ${className}`}
        >
            {children}
        </span>
    )
}
